/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'
import { useState, useCallback } from 'react'
import { ENTITY_TYPES } from '@sportninja/common/sagas/utils'

const ENTITY_PLACEHOLDER_MAP: Record<string, string> = {
  [ENTITY_TYPES.org]:
    '/images/generic_placeholders/placeholder_organization.png',
  [ENTITY_TYPES.schedule]:
    '/images/generic_placeholders/placeholder_competition.png',
  [ENTITY_TYPES.team]: '/images/generic_placeholders/placeholder_team.png',
  [ENTITY_TYPES.player]: '/images/generic_placeholders/placeholder_player.png',
  [ENTITY_TYPES.venue]: '/images/generic_placeholders/placeholder_venue.png',
}

const DEFAULT_PLACEHOLDER =
  '/images/generic_placeholders/placeholder_competition.png'

interface EntityThumbnailProps {
  imageId?: string
  entityType: string
  size?: number
  borderRadius?: number
  className?: string
}

const EntityThumbnail = ({
  imageId,
  entityType,
  size = 32,
  borderRadius = 4,
  className,
}: EntityThumbnailProps) => {
  const placeholder = ENTITY_PLACEHOLDER_MAP[entityType] || DEFAULT_PLACEHOLDER
  const [imgSrc, setImgSrc] = useState<string>(imageId || placeholder)

  const handleError = useCallback(() => {
    if (imgSrc !== placeholder) {
      setImgSrc(placeholder)
    }
  }, [imgSrc, placeholder])

  return (
    <div
      className={className}
      css={css`
        display: flex;
        width: ${size}px;
        height: ${size}px;
        min-width: ${size}px;
        min-height: ${size}px;
        justify-content: center;
        align-items: center;
        border-radius: ${borderRadius}px;
        background: #fff;
        overflow: hidden;
      `}
    >
      <img
        src={imgSrc}
        alt=''
        onError={handleError}
        css={css`
          width: 100%;
          height: 100%;
          object-fit: cover;
        `}
      />
    </div>
  )
}

export default EntityThumbnail
